export type AiEmbedContext =
  | 'society'
  | 'partners'
  | 'beneficiaries'
  | 'investors'
  | 'operations'
  | 'boards'
  | 'communications'
  | 'documents'
  | 'employees'
  | 'stockPlans'
  | 'tenderOffers'
  | 'shares';

/** i18n keys for short suggestion chips shown in EmbedFloatingComposer */
export const EMBED_AI_SUGGESTIONS: Record<AiEmbedContext, string[]> = {
  society: [
    'CHATBOT_Suggest_CapitalSummary',
    'CHATBOT_Suggest_PrepareBoardMinutes',
    'CHATBOT_Suggest_SimulateCapitalIncrease',
    'CHATBOT_Suggest_LargestShareholder',
  ],
  partners: [
    'CHATBOT_Suggest_TopPartners',
    'CHATBOT_Suggest_NewPartners',
    'CHATBOT_Suggest_PartnerCategories',
    'CHATBOT_Suggest_RepresentationAgreements',
    'CHATBOT_Suggest_InactivePartners',
  ],
  beneficiaries: [
    'CHATBOT_Suggest_BeneficiaryStatus',
    'CHATBOT_Suggest_StockPlanShares',
    'CHATBOT_Suggest_PendingInvitations',
    'CHATBOT_Suggest_VestingSchedules',
    'CHATBOT_Suggest_CliffDates',
  ],
  investors: [
    'CHATBOT_Suggest_TotalFunding',
    'CHATBOT_Suggest_TopInvestors',
    'CHATBOT_Suggest_InvestmentRounds',
    'CHATBOT_Suggest_InvestorDiscounts',
    'CHATBOT_Suggest_AverageInvestment',
  ],
  operations: [
    'CHATBOT_Suggest_RecentCapitalOps',
    'CHATBOT_Suggest_DividendDistributions',
    'CHATBOT_Suggest_ShareClassChanges',
    'CHATBOT_Suggest_ShareVolume',
    'CHATBOT_Suggest_PendingNotaryOps',
  ],
  boards: [
    'CHATBOT_Suggest_ScheduledBoards',
    'CHATBOT_Suggest_BoardAttendance',
    'CHATBOT_Suggest_DigitalVoting',
    'CHATBOT_Suggest_PendingBoardDocs',
    'CHATBOT_Suggest_CommonAgendaItems',
  ],
  communications: [
    'CHATBOT_Suggest_CommOpenRate',
    'CHATBOT_Suggest_CommRejections',
    'CHATBOT_Suggest_ScheduledComms',
    'CHATBOT_Suggest_InvalidEmails',
    'CHATBOT_Suggest_FavoriteComms',
  ],
  documents: [
    'CHATBOT_Suggest_DocsByCategory',
    'CHATBOT_Suggest_RecentDocs',
    'CHATBOT_Suggest_FavoriteDocs',
    'CHATBOT_Suggest_OperationDocs',
    'CHATBOT_Suggest_CommonDocs',
  ],
  employees: [
    'CHATBOT_Suggest_EmployeeCount',
    'CHATBOT_Suggest_ActiveContracts',
    'CHATBOT_Suggest_SalaryChanges',
    'CHATBOT_Suggest_UpcomingTerminations',
    'CHATBOT_Suggest_SalaryRanges',
  ],
  stockPlans: [
    'CHATBOT_Suggest_ActivePlans',
    'CHATBOT_Suggest_CustomVesting',
    'CHATBOT_Suggest_PendingPlanInvites',
    'CHATBOT_Suggest_LiquidatedPlans',
    'CHATBOT_Suggest_ExercisePrices',
  ],
  tenderOffers: [
    'CHATBOT_Suggest_ActiveOffers',
    'CHATBOT_Suggest_ExpiringOffers',
    'CHATBOT_Suggest_OfferRestrictions',
    'CHATBOT_Suggest_PlanTargetedOffers',
    'CHATBOT_Suggest_AverageOfferPrice',
  ],
  shares: [
    'CHATBOT_Suggest_ShareDistribution',
    'CHATBOT_Suggest_ShareEncumbrances',
    'CHATBOT_Suggest_UpcomingVesting',
    'CHATBOT_Suggest_InactiveShares',
    'CHATBOT_Suggest_ShareRanges',
  ],
};
